import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService } from '../../../../../Autofacets-Core/src/app/services/data.service';
import { AppConfig } from '../../helper/config/api.config';

@Injectable({
  providedIn: 'root'
})
export class CarParkingService {
  constructor(
    private dataProvider: DataService
  ) { }

  getVehicleParkedLocationImage(): Promise<any> {
    return this.dataProvider.Get(AppConfig.GET_VEHICLE_PARKED_LOCATION_URL).toPromise();
  }

  saveCustomerDropOffVehicleMarking(modal: any) {
    return this.dataProvider.Post(AppConfig.CUSTOMER_DROP_OFF_VEHICLE_MARKING_URL, modal);
  }

  getVehicleParkedLocationBaseUrl(locationUrl: any): Observable<any> {
    return this.dataProvider.Get(AppConfig.GET_VEHICLE_PARKED_BASE_URL, locationUrl);
  }
}
